import { render } from "./AddItemsByObjectGroup.vue?vue&type=template&id=6ca0cb41"
import script from "./AddItemsByObjectGroup.vue?vue&type=script&lang=js"
export * from "./AddItemsByObjectGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__